import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./questionReports.module.css";
import userInfoStyles from "../userInfo/userInfo.module.css";
import { useParams } from "react-router-dom";
import BackArrowButton from "../backArrowButton/backArrowButton";
import { IOption } from "../../types/types";

import { noDataLabel, selectCustomStyles } from "../../utils/constants";
import React, { useEffect, useRef, useState } from "react";
import QuestionReport from "../questionReport/questionReport";
import { useAppSelector } from "../../services/hooks";
import UserInfo from "../userInfo/userInfo";
import {
  useAddMessageToScoreMutation,
  useGetRRMListMutation,
  useGetAllQuestionnairesByUserIdQuery,
  useLazyGetMultipleQuestionnairesByUserIdAndCycleQuery,
} from "../../services/api/user.api";
import {
  TRRMListEntry,
  TQuestionnaire,
  TQuestionnaireEntry,
  TQuestionnaireQuestion,
  TQuestionnaireScore,
} from "../../services/types/user.types";
import RrmScoresSection from "../rrmScoresSection/rrmScoresSection";
import { getPrintDate, getTimeFromTimestamp } from "../../utils/utils";
import Select, { SingleValue } from "react-select";
import Modal from "../modals/modal/Modal";
import AddRecommendationPopup from "../modals/addRecommendation/addRecommendation";
import ErrorPopup from "../modals/errorPopup/errorPopup";
import GeneralSuccessPopup from "../modals/generalSuccessPopup/generalSuccessPopup";
import { IUserReport } from "../../services/types/users.types";
import {
  adminSelector,
  RRMListSelector,
} from "../../services/selectors/user.selectors";
import { isChargingCustomersSelector } from "../../services/selectors/auth.selectors";
import QuestionReportCommentsPopup from "../modals/questionReportCommentsPopup/questionReportCommentsPopup";
import PaymentDetailsPopup from "../modals/paymentDetailsPopup/paymentDetailsPopup";
import { useActions } from "../../services/hooks/useActions";
import ExportButtons from "../exportButtons/exportButtons";
import { useGetCompanyByIdQuery } from "../../services/api/utils.api";

function QuestionReports({
  user,
  onClose,
}: {
  user: IUserReport;
  onClose: () => void;
}) {
  const { id } = useParams();
  const userId = id as string;

  const admin = useAppSelector(adminSelector);
  const showPaymentFeatures = useAppSelector(isChargingCustomersSelector);
  const { data: currentCompany } = useGetCompanyByIdQuery(admin.companyId, {
    skip: !admin.companyId,
  });
  const isChargingCustomers = currentCompany?.isChargingCustomers;

  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [cycle, setCycle] = useState<number | null>(null);
  const [QuestionnaireCompaniesId, setQuestionnaireCompaniesId] =
    useState<number>(-1);
  const [allReports, setAllReports] = useState<TQuestionnaireEntry[]>([]);
  const [latestActionReport, setLatestActionReport] = useState<
    Record<string, TQuestionnaireEntry[]> | []
  >([]);
  const [latestUserReport, setLatestUserReport] = useState<
    Record<string, TQuestionnaireEntry[]> | []
  >([]);
  const [sources, setSources] = useState<
    { QuestionnairId: number; QuestionnairDesc: string }[] | undefined
  >(undefined);
  const [reportToShow, setReportToShow] = useState<
    | {
        questionnaire: TQuestionnaire;
        results: TQuestionnaireQuestion[];
        score: number;
        rrm: TQuestionnaireScore | null;
        rrmList: TRRMListEntry[];
        totalAmount?: number | null;
      }
    | undefined
  >(undefined);
  const [actionReport, setActionReport] = useState<
    | {
        questionnaire: TQuestionnaire;
        results: TQuestionnaireQuestion[];
        score: number;
        rrm: TQuestionnaireScore | null;
        rrmList: TRRMListEntry[];
        totalAmount?: number | null;
        totalAmountPay?: number | null;
        questionnaireCompaniesScoreUsersStatuses?: number | null;
      }
    | undefined
  >(undefined);
  const [reportsDateOptions, setReportsDateOptions] = useState<IOption[]>([]);
  const [actionReportsDateOptions, setActionReportsDateOptions] = useState<
    IOption[]
  >([]);
  const [openModal, setOpenModal] = useState(false);
  const [openUpdatesModal, setOpenUpdatesModal] = useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [addMessageToTheScore] = useAddMessageToScoreMutation();
  const [messagesByScore, setMessagesByScore] = useState<TQuestionnaireScore[]>(
    []
  );
  const [activeTab, setActiveTab] = useState("patient");
  const [initialViewTab, setInitialViewTab] = useState("patient");
  const [openPaymentDetailsModal, setOpenPaymentDetailsModal] = useState(false);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const exportDropdownRef = useRef<HTMLDivElement>(null);

  const closeAllModals = () => {
    setOpenModal(false);
    setOpenModalSuccess(false);
    setOpenModalError(false);
  };
  const [getMultipleReportsByUserIdAndCycle] =
    useLazyGetMultipleQuestionnairesByUserIdAndCycleQuery();

  const RRMListDefault = useAppSelector(RRMListSelector);
  const [getRRMList] = useGetRRMListMutation();

  useEffect(() => {
    if (!RRMListDefault?.length) {
      getRRMList({ type: 1, companyId: admin.companyId });
    }
  }, [admin.companyId, RRMListDefault, getRRMList]);

  useEffect(() => {
    cycle !== null &&
      getMultipleReportsByUserIdAndCycle({
        UsersGuid: user.Users.Guid || "",
        Cycle: cycle,
        QuestionnaireCompaniesId: QuestionnaireCompaniesId,
      }).then((res) => {
        if ("data" in res && res.data?.UserQuestionnaire) {
          const scoreDataUR =
            res.data.RRMAndScore?.find(
              (item) =>
                item.QuestionnaireId ===
                  res.data?.UserQuestionnaire?.Questionnaire?.Id &&
                item.QuestionnaireCompaniesId === QuestionnaireCompaniesId &&
                item.Cycle === cycle
            ) ?? null;
          const scoreDataTR =
            res.data.RRMAndScore?.find(
              (item) =>
                item.QuestionnaireId ===
                  res.data?.TherapistQuestionnaire?.Questionnaire?.Id &&
                item.QuestionnaireCompaniesId === QuestionnaireCompaniesId &&
                item.Cycle === cycle
            ) ?? null;

          scoreDataUR
            ? setReportToShow({
                questionnaire: res.data.UserQuestionnaire.Questionnaire,
                results: res.data.UserQuestionnaire.Questions,
                score: scoreDataUR.Score || 0,
                rrm: scoreDataUR,
                rrmList: res.data.RRMList,
              })
            : scoreDataTR && setReportToShow(undefined);
          scoreDataTR
            ? setActionReport({
                questionnaire: res.data.TherapistQuestionnaire.Questionnaire,
                results: res.data.TherapistQuestionnaire.Questions,
                score: scoreDataTR.Score || 0,
                rrm: scoreDataTR,
                rrmList: res.data.RRMList,
                totalAmount: res.data.TherapistQuestionnaire.Questionnaire.TotalAmount ?? null,
                totalAmountPay: res.data.TherapistQuestionnaire.Questionnaire.TotalAmountPay ?? null,
                questionnaireCompaniesScoreUsersStatuses: res.data.TherapistQuestionnaire.Questionnaire.QuestionnaireCompaniesScoreUsersStatuses ?? null,

              })
            : setActionReport(undefined);
          setMessagesByScore(res.data.RRMAndScore || []);

          const tempSources = [];
          scoreDataTR &&
            tempSources.push({
              QuestionnairId: res.data.TherapistQuestionnaire.Questionnaire.Id,
              QuestionnairDesc:
                res.data.TherapistQuestionnaire.Questionnaire.Desc,
            });
          scoreDataUR &&
            tempSources.push({
              QuestionnairId: res.data.UserQuestionnaire.Questionnaire.Id,
              QuestionnairDesc: res.data.UserQuestionnaire.Questionnaire.Desc,
            });
          setSources(tempSources);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cycle, getMultipleReportsByUserIdAndCycle, userId, refreshTrigger]);

  const { data } =
    // @ts-ignore
    useGetAllQuestionnairesByUserIdQuery({
      guid: user.Users.Guid || "",
    });

  useEffect(() => {
    if (data) {
      setAllReports([
        ...data.QuestionnairesUsers,
        ...data.QuestionnairesTherapists,
      ]);
      const latestReportUsersGroup = groupByQuestionnaireCompaniesId(
        data.QuestionnairesUsers
      );
      const latestReportTherapistsGroup = groupByQuestionnaireCompaniesId(
        data.QuestionnairesTherapists
      );
      latestReportUsersGroup && setLatestUserReport(latestReportUsersGroup);
      latestReportTherapistsGroup &&
        setLatestActionReport(latestReportTherapistsGroup);

      const newPatientOptions: IOption[] = [];
      const newTherapistOptions: IOption[] = [];

      Object.values(latestReportUsersGroup).forEach((que) => {
        const options = que.map((qu) => ({
          label: `${getPrintDate(
            new Date(qu.Timestamp),
            true
          )} (${getTimeFromTimestamp(new Date(qu.Timestamp))}) (${qu.Cycle})`,
          value: `${qu.Timestamp}|${qu.Cycle}`,
          QuestionnaireCompaniesId: qu.QuestionnaireCompaniesId,
        }));
        newPatientOptions.push(...options);
      });

      Object.values(latestReportTherapistsGroup).forEach((que) => {
        const options = que.map((qu) => ({
          label: `${getPrintDate(
            new Date(qu.Timestamp),
            true
          )} (${getTimeFromTimestamp(new Date(qu.Timestamp))}) (${qu.Cycle})`,
          value: `${qu.Timestamp}|${qu.Cycle}`,
          QuestionnaireCompaniesId: qu.QuestionnaireCompaniesId,
        }));
        newTherapistOptions.push(...options);
      });

      setReportsDateOptions(newPatientOptions);
      setActionReportsDateOptions(newTherapistOptions);
    }
  }, [data, user]);

  useEffect(() => {
    if (reportToShow || actionReport) {
      if (activeTab === "patient" && !reportToShow && actionReport) {
        setActiveTab("therapist");
      }
    }
  }, [reportToShow, actionReport, activeTab]);

  // Close export dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(e.target as Node)) {
        setShowExportDropdown(false);
      }
    };
    if (showExportDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showExportDropdown]);

  const groupByQuestionnaireCompaniesId = (
    items: TQuestionnaireEntry[]
  ): Record<string, TQuestionnaireEntry[]> => {
    const grouped = items.reduce<Record<string, TQuestionnaireEntry[]>>(
      (acc, item) => {
        if (!acc[item.QuestionnaireCompaniesId]) {
          acc[item.QuestionnaireCompaniesId] = [];
        }
        acc[item.QuestionnaireCompaniesId].push(item);
        return acc;
      },
      {}
    );
    Object.keys(grouped).forEach((key) => {
      grouped[key].sort((a, b) => b.Cycle - a.Cycle);
    });
    return grouped;
  };

  const onSelectChange = (newValue: SingleValue<IOption>) => {
    const [, cycleStr] = (newValue?.value ?? "").split("|");
    const newCycle = parseInt(cycleStr, 10);
    if (!isNaN(newCycle)) {
      setCycle(newCycle);
    }
  };
  // console.log(reportToShow);
  const { clearQuestionReportComments } = useActions();

  return (
    <article className={styles.section}>
      <div className={styles.pageHeader}>
        <BackArrowButton
          text={t("PREVIOUS_SCREEN")}
          onClick={() => {
            if (reportToShow || actionReport) {
              setActionReport(undefined);
              setReportToShow(undefined);
              setCycle(null);
            } else onClose();
          }}
          position={"center"}
        />
        <h2 className={`title`}>
          {reportToShow || actionReport
            ? t("QUESTIONNAIRE_REPORTS")
            : ` ${t("QUESTIONNAIRE_REPORTS_FOR_USER")} ${
                user.Users.FirstName
              } ${user.Users.LastName || ""}`}
        </h2>
      </div>
      {reportToShow || actionReport ? (
        <article className={styles.table}>
          <div className={styles.reportHeader}>
            <div className={styles.topRow}>
              {user && <UserInfo user={user} />}

              {/* <div className={styles.headerSource}>
              <p className={`${userInfoStyles.user__label} ${userInfoStyles.form__subtitle}`}>{t('SOURCE')}</p>
                <ul className={styles.sources}>
                    {sources && sources.map((s, index) => (
                      <li key={index} className={userInfoStyles.user__text}>
                        {s.QuestionnairDesc}
                        {index < sources.length - 1 ? "," : ""}
                    </li>
                    ))}
                </ul>
            </div> */}

              <div className={styles.headerSelect}>
                <Select
                  name={"reportDate"}
                  className={styles.select}
                  options={
                    activeTab === "patient"
                      ? reportsDateOptions.filter(
                          (q) =>
                            q.QuestionnaireCompaniesId ===
                            QuestionnaireCompaniesId
                        )
                      : actionReportsDateOptions.filter(
                          (q) =>
                            q.QuestionnaireCompaniesId ===
                            QuestionnaireCompaniesId
                        )
                  }
                  value={
                    (activeTab === "patient"
                      ? reportsDateOptions
                      : actionReportsDateOptions
                    ).find((r) => {
                      const found = allReports
                        .filter(
                          (qu) =>
                            qu.QuestionnaireCompaniesId ===
                            QuestionnaireCompaniesId
                        )
                        .find(
                          (rep) =>
                            rep.QuestionnaireId ===
                              (activeTab === "patient"
                                ? reportToShow?.questionnaire.Id
                                : actionReport?.questionnaire.Id) &&
                            rep.Cycle === cycle
                        );
                      return found
                        ? r.value === `${found.Timestamp}|${found.Cycle}`
                        : false;
                    }) || null
                  }
                  onChange={onSelectChange}
                  styles={selectCustomStyles}
                  isDisabled={
                    (activeTab === "patient"
                      ? reportsDateOptions
                      : actionReportsDateOptions
                    ).length < 1
                  }
                  placeholder={t(noDataLabel)}
                />
              </div>
            </div>

            <div className={styles.bottomRow}>
              <div className={styles.bottomRowLeft}>
                <div className={styles.actionsWrapper}>
                  <div className={styles.actionsRow}>
                    <button
                      className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
                      onClick={() => setOpenModal(true)}
                    >
                      {t("ADD_RECOMMENDATION")}
                    </button>

                    <button
                      type="button"
                      className={styles.actionButton}
                      onClick={() => setOpenUpdatesModal(true)}
                    >
                      {t("SHOW_COMMENTS")}
                    </button>

                    {cycle !== null &&
                      ((activeTab === "patient" && reportToShow) ||
                        (activeTab === "therapist" && actionReport)) && (
                        <div className={styles.exportDropdown} ref={exportDropdownRef}>
                          <button
                            type="button"
                            className={styles.actionButton}
                            onClick={() =>
                              setShowExportDropdown(!showExportDropdown)
                            }
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M3 15c0 2.828 0 4.243.879 5.121C4.757 21 6.172 21 9 21h6c2.828 0 4.243 0 5.121-.879C21 19.243 21 17.828 21 15M12 3v13m0 0 4-4.375M12 16l-4-4.375" />
                              </g>
                            </svg>
                          </button>
                          {showExportDropdown && (
                            <div className={styles.dropdownContent}>
                              <ExportButtons
                                key={`${activeTab}-${cycle}-${QuestionnaireCompaniesId}`}
                                reportType={
                                  activeTab === "patient"
                                    ? "questionnaire"
                                    : "therapist-action"
                                }
                                userId={user.Users.Id}
                                questionnaireId={
                                  activeTab === "patient"
                                    ? reportToShow?.questionnaire.Id || 0
                                    : actionReport?.questionnaire.Id || 0
                                }
                                questionnaireCompaniesId={
                                  QuestionnaireCompaniesId
                                }
                                cycle={cycle}
                                therapistId={
                                  activeTab === "therapist"
                                    ? actionReport?.rrm?.TherapistsId ||
                                      undefined
                                    : undefined
                                }
                                size="medium"
                              />
                            </div>
                          )}
                        </div>
                      )}
                    {activeTab === "therapist" && showPaymentFeatures && (
                      <>
                        <div className={styles.paymentInfo}>
                          <button
                            type="button"
                            className={`button ${styles.btn} ${styles.btn_disabled} button_white`}
                            data-testid="charge-user-button"
                            disabled={true}
                          >
                            {t("ACTION_REPORT_CHARGE_USER_BUTTON") || "Charge User"}
                          </button>
                          <div className={styles.paymentInfoItem}>
                            <span className={styles.paymentLabel}>
                              {t("ACTION_REPORT_SESSION_PRICE_LABEL") || "Session Cost:"}
                            </span>
                            <span className={styles.paymentValue}>
                              ₪{actionReport?.totalAmount?.toFixed(2) ?? 0}
                            </span>
                          </div>
                        </div>
                        {actionReport?.totalAmountPay != null && (
                          <div className={styles.paymentInfo}>
                            <span className={`${styles.btn} ${styles.paidBadge}`}>
                              {t("PAID_BADGE") || "Paid"}
                            </span>
                            <div className={styles.paymentInfoItem}>
                              <span className={styles.paymentLabel}>
                                {t("PAYMENT_POPUP_CHARGE_AMOUNT")}
                              </span>
                              <span className={styles.paymentValuePaid}>
                                ₪{actionReport.totalAmountPay.toFixed(2)}
                              </span>
                            </div>
                          </div>
                        )}
                        {actionReport?.questionnaireCompaniesScoreUsersStatuses != null && (
                          <div className={styles.paymentInfo}>
                            <p className={`${styles.user__label} ${userInfoStyles.form__subtitle}`}>
                              {t("APPOINTMENT_STATUS")}:
                            </p>
                            <span className={userInfoStyles.user__text}>
                              {actionReport.questionnaireCompaniesScoreUsersStatuses || ""}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              {((activeTab === "patient" && reportToShow?.rrm) ||
                (activeTab === "therapist" &&
                  actionReport?.rrm &&
                  actionReport.score > 0)) && (
                <div className={styles.bottomRowRrm}>
                  <RrmScoresSection
                    score={
                      (activeTab === "therapist" && actionReport
                        ? actionReport.score
                        : reportToShow?.score) ?? 0
                    }
                    rrm={
                      activeTab === "therapist" && actionReport
                        ? actionReport.rrm
                        : reportToShow?.rrm
                    }
                    rrmList={
                      (activeTab === "therapist" && actionReport
                        ? actionReport.rrmList
                        : reportToShow?.rrmList) ?? RRMListDefault
                    }
                  />
                </div>
              )}
            </div>
            <div className={styles.titleAndReporterContainer}>
              <div className={styles.bottomRowRight}>
                <p className={styles.questionnaireName}>
                  {activeTab === "patient" && reportToShow?.questionnaire.Desc}
                  {activeTab === "therapist" && actionReport?.questionnaire.Desc}
                </p>
              </div>
              {activeTab === "therapist" && actionReport && (
                <div className={styles.headerReportingFactor}>
                  <p
                    className={`${userInfoStyles.user__label} ${userInfoStyles.form__subtitle}`}
                  >
                    {t("REPORTING_FACTOR")}
                  </p>
                  <span className={userInfoStyles.user__text}>
                    {actionReport.rrm?.TherapistsName || t(noDataLabel)}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div
            className={`${styles.tabsContainer} ${styles.innerTabsContainer}`}
          >
            <div className={styles.tabsButtons}>
              <button
                className={`${styles.tabButton} ${
                  activeTab === "patient" ? styles.activeTab : ""
                }`}
                onClick={() => setActiveTab("patient")}
                disabled={!reportToShow}
              >
                {t("COLUMN_USER_QUESTIONNAIRE")}
              </button>
              <button
                className={`${styles.tabButton} ${
                  activeTab === "therapist" ? styles.activeTab : ""
                }`}
                onClick={() => setActiveTab("therapist")}
                disabled={!actionReport}
              >
                {t("TREATMENT_REPORT")}
              </button>
            </div>

            <div className={styles.tabsStatusRow}>
              {/* Payment Status - only show for therapist tab when company charges customers */}
              {activeTab === "therapist" && 
                isChargingCustomers && 
                (actionReport?.questionnaire?.TotalAmount ?? 0) > 0 && (
                <>
                  {/* Show payment request if not fully paid */}
                  {(actionReport?.questionnaire?.TotalAmountPay ?? 0) < (actionReport?.questionnaire?.TotalAmount ?? 0) && (
                    <div className={styles.paymentCard}>
                      <button
                        type="button"
                        className={styles.paymentRequestBtn}
                        onClick={() => {
                          // TODO: Open payment modal
                        }}
                      >
                        {t("PAYMENT_REQUEST")}
                      </button>
                      <span className={styles.warningIcon}>⚠</span>
                    </div>
                  )}

                  {/* Show paid button if there's any payment */}
                  {(actionReport?.questionnaire?.TotalAmountPay ?? 0) > 0 && (
                    <div className={styles.paidCardWrapper}>
                      <button
                        type="button"
                        className={styles.paidBtn}
                        onClick={() => {
                          setOpenPaymentDetailsModal(!openPaymentDetailsModal);
                        }}
                      >
                        {t("PAID")}
                      </button>
                      {openPaymentDetailsModal && (
                        <PaymentDetailsPopup
                          onClose={() => setOpenPaymentDetailsModal(false)}
                        />
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* The content inside the tabs is now just the report table */}
          <div className={styles.tabContent}>
            {activeTab === "patient" && reportToShow && (
              <QuestionReport report={reportToShow} />
            )}

            {activeTab === "therapist" && actionReport && (
              <QuestionReport report={actionReport} />
            )}
          </div>
        </article>
      ) : (
        <>
          <div className={styles.tabsContainer}>
            <button
              className={`${styles.tabButton} ${
                initialViewTab === "patient" ? styles.activeTab : ""
              }`}
              onClick={() => setInitialViewTab("patient")}
            >
              {t("COLUMN_USER_QUESTIONNAIRE")}
            </button>
            <button
              className={`${styles.tabButton} ${
                initialViewTab === "therapist" ? styles.activeTab : ""
              }`}
              onClick={() => setInitialViewTab("therapist")}
            >
              {t("TREATMENT_REPORT")}
            </button>
          </div>
          <div className={`${styles.editOtionsTable} ${styles.editOptions}`}>
            <ul className={styles.reportList}>
              {initialViewTab === "patient" ? (
                !Array.isArray(latestUserReport) &&
                Object.keys(latestUserReport).length > 0 ? (
                  Object.entries(latestUserReport).map(
                    ([questionnaireId, Report]) => (
                      <li
                        key={questionnaireId}
                        className={`${styles.editOption} hover`}
                        onClick={() => {
                          setCycle(Report[0].Cycle);
                          setQuestionnaireCompaniesId(
                            Report[0].QuestionnaireCompaniesId
                          );
                          setActiveTab("patient");
                        }}
                      >
                        {Report[0].Desc} {t("RETURN_CYCLE")} {Report[0].Cycle})
                        <span className={styles.editOptionComment}>
                          {getPrintDate(new Date(Report[0].Timestamp))} (
                          {getTimeFromTimestamp(new Date(Report[0].Timestamp))})
                        </span>
                        <span className={styles.editOptionCommentSmall}>
                          {t("COLUMN_USER_QUESTIONNAIRE")}
                        </span>
                      </li>
                    )
                  )
                ) : (
                  <p>{t("NO_PATIENT_REPORTS_FOUND")}</p>
                )
              ) : !Array.isArray(latestActionReport) &&
                Object.keys(latestActionReport).length > 0 ? (
                Object.entries(latestActionReport).map(
                  ([questionnaireId, Report]) => (
                    <li
                      key={questionnaireId}
                      className={`${styles.editOption} hover`}
                      onClick={() => {
                        setCycle(Report[0].Cycle);
                        setQuestionnaireCompaniesId(
                          Report[0].QuestionnaireCompaniesId
                        );
                        setActiveTab("therapist");
                      }}
                    >
                      {isChargingCustomers && 
                        (Report[0].TotalAmount ?? 0) > 0 && 
                        (Report[0].TotalAmountPay ?? 0) < (Report[0].TotalAmount ?? 0) && (
                        <span
                          className={styles.debtWarningBadge}
                          title={t("PAYMENT_PENDING")}
                        >
                          ⚠
                        </span>
                      )}
                      {Report[0].Desc} {t("RETURN_CYCLE")}
                      {Report[0].Cycle})
                      <span className={styles.editOptionComment}>
                        {getPrintDate(new Date(Report[0].Timestamp))} (
                        {getTimeFromTimestamp(new Date(Report[0].Timestamp))})
                      </span>
                      <span className={styles.editOptionCommentSmall}>
                        {t("TREATMENT_REPORT")}
                      </span>
                    </li>
                  )
                )
              ) : (
                <p>{t("NO_REPORTS_FOUND")}</p>
              )}
            </ul>
          </div>
        </>
      )}
      {openModal && user && (
        <Modal onClose={() => setOpenModal(false)}>
          <AddRecommendationPopup
            user={user}
            addMessageToScore={(form: { Title: string; Desc: string }) => {
              sources &&
                addMessageToTheScore({
                  QuestionnaireIds: sources
                    .map((s) => s.QuestionnairId)
                    .join(","),
                  MessageId: "0",
                  Title: form.Title,
                  Desc: form.Desc,
                  Score: reportToShow?.score.toString() ?? "0",
                  UsersId: user.Users.Id.toString(),
                  Cycle: cycle,
                })
                  .then((res) => {
                    if (
                      "data" in res ||
                      // @ts-ignore
                      ("error" in res && res.error.originalStatus === 200)
                    ) {
                      setOpenModal(false);
                      setOpenModalSuccess(true);
                    } else {
                      setOpenModal(false);
                      setOpenModalError(true);
                    }
                  })
                  .finally(
                    () =>
                      cycle &&
                      getMultipleReportsByUserIdAndCycle({
                        UsersGuid: user.Users.Guid || "",
                        Cycle: cycle,
                        QuestionnaireCompaniesId: QuestionnaireCompaniesId,
                      }).then((res) => {
                        const newMessageList = res.data?.RRMAndScore || [];
                        setMessagesByScore(newMessageList);
                      })
                  );
            }}
          />
        </Modal>
      )}
      {openModalSuccess && (
        <Modal onClose={closeAllModals}>
          <GeneralSuccessPopup onClose={closeAllModals} />
        </Modal>
      )}
      {openModalError && (
        <Modal onClose={closeAllModals}>
          <ErrorPopup onClose={closeAllModals} />
        </Modal>
      )}
      {openUpdatesModal && reportToShow?.rrm && (
        <Modal
          wide={true}
          onClose={() => {
            setOpenUpdatesModal(false);
            clearQuestionReportComments();
          }}
        >
          <QuestionReportCommentsPopup
            usersGuid={user.Users.Guid || ""}
            questionnaireId={reportToShow.questionnaire.Id}
            questionnaireCompaniesId={reportToShow.rrm.QuestionnaireCompaniesId}
            cycle={reportToShow.rrm.Cycle}
          />
        </Modal>
      )}
    </article>
  );
}

export default QuestionReports;
